import React from 'react';
import { observer } from 'mobx-react';

import { Box, IconButton } from 'components';
import { Download } from 'icons';

const alignCenterStyle = {
  display: 'flex',
  alignItems: 'center',
};

interface ActionButtonsProps {
  receiptUrl?: string;
}

export const ActionButtons = observer(function ActionButtons({
  receiptUrl,
}: ActionButtonsProps) {
  if (!receiptUrl) {
    return null;
  }

  return (
    <Box sx={alignCenterStyle}>
      <a download href={receiptUrl}>
        <IconButton variant='outlined' icon={<Download />} mr={4} />
      </a>
    </Box>
  );
});
